import type { SVGProps } from 'react';
export const IconKitTv = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6 4.5h12A3.5 3.5 0 0 1 21.5 8v6a3.5 3.5 0 0 1-3.5 3.5H6A3.5 3.5 0 0 1 2.5 14V8A3.5 3.5 0 0 1 6 4.5Z"
      stroke="currentColor"
    />

    <path
      fill="currentColor"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8.479 14V8.623H6.706V7.7h4.554v.923H9.487V14H8.479Zm3.157-6.3h2.921c1.463 0 2.318.585 2.318 1.634 0 .679-.387 1.187-1.049 1.453.797.207 1.265.792 1.265 1.553 0 1.084-.9 1.66-2.394 1.66h-3.061V7.7Zm1.008.887v1.79h1.783c.94 0 1.399-.301 1.399-.9 0-.598-.459-.89-1.399-.89h-1.783Zm0 2.659v1.867h1.927c.976 0 1.471-.31 1.471-.936 0-.621-.495-.931-1.471-.931h-1.927Z"
    />

    <path
      d="M5 20h14"
      stroke="currentColor"
      stroke-linecap="round"
    />
  </svg>
);
